import { Injectable } from '@angular/core';


import { CmsService } from '../cms/service.service';

@Injectable({
  providedIn: 'root'
})
export class CMSResolver  {
  constructor(private cmsService: CmsService) { }

  async resolve() {
     return this.cmsService.getContent();
  }

}
